import React from "react";

import { Outlet, useAppType } from "utils";

import { SoilSightMobileScreen } from "pages/app/scenario-analysis/components/SoilSightMobileScreen";

export const SoilSightDesktopOnly = () => {
  const { mobile } = useAppType();
  if (!mobile) return <Outlet />;
  return (
    <section className="page in-app">
      <SoilSightMobileScreen />
    </section>
  );
};
